export default __webpack_public_path__ + "static/media/ic_app_b.e400e896.svg";